import { useState } from 'react'
import Button from '../../../../common/Button'
import classes from './RequestDetails.module.css'
import UpdateRequest from './UpdateRequest'
import RequestSendMessage from './RequestSendMessage'
import RequestMessagesList from './RequestMessagesList'
import ResolveRequest from './ResolveRequest'
import RejectResolveRequest from './RejectResolveRequest'
import { formatDateLocalWithTimeWithoutSeconds } from '../../../../../lib/script'

export default function RequestDetails({request, refreshRequests}) {
    const [showUpdateRequest, setShowUpdateRequest] = useState(false)
    const [refreshMessagesFlag, setRefreshMessagesFlag] = useState(0)
    const [loading, setLoading] = useState(false)
    
    function closeUpdateRequestHandler() {
        setShowUpdateRequest(false)
    }
    async function showUpdateRequestHandler() {
        if (showUpdateRequest) {
            setShowUpdateRequest(false)
            return
        }
        setShowUpdateRequest(true)        
    }

    function refreshMessagesHandler() {
        setRefreshMessagesFlag(prev => prev + 1)
    }
    return <div className={classes.container}>
        <div className={classes.header}>
           {request.is_resolved ? <RejectResolveRequest request={request} refreshRequests={refreshRequests} /> 
           : 
           <ResolveRequest request={request} refreshRequests={refreshRequests} />
           }

        <Button title='Refresh Messages' btnStyle='btn_small' click={refreshMessagesHandler} isLoading={loading}><i className='ti ti-refresh'></i></Button>
           {/* {!request.is_resolved && <Button title='Update Request' btnStyle='btn_small' click={showUpdateRequestHandler}>
                {!showUpdateRequest ? 'Update Request' : 'Cancel Update'}
            </Button>} */}
        </div>
        <div className={classes.body}>
            {showUpdateRequest && <UpdateRequest request={request} closeUpdateRequestHandler={closeUpdateRequestHandler} refreshRequests={refreshRequests} />}
            {!showUpdateRequest && <div className={classes.request_details_container}>
                <div className={classes.request_details}>
                    <h3 className={classes.title}>{request.title}</h3>
                    <div className={classes.info_container}>
                        {request.added_by} at {formatDateLocalWithTimeWithoutSeconds(request.created_at)}
                        {/* {request.description} */}
                    </div>
                </div>

                <div className={classes.request_details_message}>
                    <RequestMessagesList request={request} refreshMessagesFlag={refreshMessagesFlag} setLoadingHandler={setLoading} />
                    <RequestSendMessage request={request} refreshRequests={refreshRequests} setRefreshMessagesFlag={() => setRefreshMessagesFlag(prev => prev + 1)} />
                </div>
            </div>}
        </div>
    </div>
}